import React from "react";

/**
 * <Marquee> — infinite horizontal scroll of feature tags. Pure CSS
 * animation so it's cheap and runs on mobile too. Tags repeat twice
 * inside the track to create a seamless loop.
 */
const DEFAULT_TAGS = [
  "AI Coaching",
  "Adaptive Workouts",
  "Progressive Overload",
  "Smart Recovery",
  "Habit Building",
  "Video Demos",
  "Streak Tracking",
  "Personal Records",
  "Daily Check-ins",
  "Pure Focus",
];

export default function Marquee({ tags = DEFAULT_TAGS, speed = 40 }) {
  // Duplicate for a seamless loop.
  const doubled = [...tags, ...tags];

  return (
    <div
      className="marquee"
      aria-hidden
      style={{ "--marquee-speed": `${speed}s` }}
    >
      <div className="marquee-fade marquee-fade-left" />
      <div className="marquee-fade marquee-fade-right" />
      <div className="marquee-track">
        {doubled.map((tag, i) => (
          <span key={i} className="marquee-tag">
            <span className="marquee-dot" />
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
